import React from 'react';

function InfectedWounds() {
  return (
    <div>
      <h2>Infected Wounds</h2>
      <p>Here we provide specialized care for infected wounds...</p>
    </div>
  );
}

export default InfectedWounds;
